import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import { restActionFactory } from "../../toolkit/axiosActions/axiosActionsFactory";
import constants from "../../utils/constants";
import axios from "axios";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";

const CODIGOS_EMPLEADO_BASE_URL = "/api/codigos-empleado";

const codigosEmpleadoRestAction = restActionFactory(
  `${constants.BASE_URL}${CODIGOS_EMPLEADO_BASE_URL}`
);

export const getCodigosEmpleadoByUser = (idUser: number): IAction => {
  return codigosEmpleadoRestAction({
    actionType: actionTypes.GET_CODIGOS_EMPLEADO_BY_USER,
    urlComplement: `/empleados/${idUser}`,
    method: "get"
  });
};

export const getCodigosEmpleadoByCodigo = (codigo: string): IAction => {
  return codigosEmpleadoRestAction({
    actionType: actionTypes.GET_CODIGOS_EMPLEADO_BY_CODIGO,
    urlComplement: `/codigos/${codigo}`,
    method: "get"
  });
};

export const postCodigoEmpleado = (idUser: number): IAction => {
  return codigosEmpleadoRestAction({
    actionType: actionTypes.POST_CODIGO_EMPLEADO,
    urlComplement: `/empleados/${idUser}`,
    method: "post"
  });
};

export const postEnviarComunicadoCodigosEmpleado = (
  idUser: number
): IAction => {
  return codigosEmpleadoRestAction({
    actionType: actionTypes.POST_ENVIAR_COMUNICADO_CODIGOS_EMPLEADO,
    urlComplement: `/empleados/${idUser}/comunicado`,
    method: "post"
  });
};

export const downloadCodigosRedimidosReporte = (callback?: any) => {
  return axios
    .get(
      `${constants.BASE_URL}${CODIGOS_EMPLEADO_BASE_URL}/codigos-redimidos/reporte`,
      {
        withCredentials: true,
        responseType: "blob"
      }
    )
    .then(({ data }) => {
      FileDownload(data, "ReporteCodigosRedimidos.csv");
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de códigos redimidos");
      callback && callback(error);
    });
};

export const clearCodigosEmpleado = (): IAction => {
  return {
    type: actionTypes.CLEAR_CODIGOS_EMPLEADO
  };
};
